import { render, staticRenderFns } from "./SponsorshipConfig.vue?vue&type=template&id=16793d94&scoped=true"
import script from "./SponsorshipConfig.vue?vue&type=script&lang=js"
export * from "./SponsorshipConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16793d94",
  null
  
)

export default component.exports